// Selectors
import * as ProductSelectors from '~/selectors/ProductSelectors';
// Action Types
import AnalyticsTypes from '~/constants/types/AnalyticsTypes';
import ProductTypes from '~/constants/types/ProductTypes';
// Utils
import {normalizeTagName} from '~/utils/analytics';

export const AddProducts = {
  start: () => ({
    event: 'lab_add_products_start'
  }),
  productSelected: (state, {payload}) => {
    const selectedProduct =
      ProductSelectors.getStyleDataForStyleId(state)(payload);
    const currentColor = selectedProduct?.colors?.find(
      color => color?.id === payload
    );
    return {
      event: 'lab_add_products_selected',
      color: normalizeTagName(currentColor?.name),
      style: selectedProduct?.id
    };
  },
  productAdded: (state, {payload}) => {
    const {products} = payload;
    const selectedStyle = products?.length > 0 ? products[0] : null;
    const selectedProduct = ProductSelectors.getStyleDataForStyleId(state)(
      selectedStyle?.styleId
    );
    const currentColor = selectedProduct?.colors?.find(
      color => color?.id === selectedStyle?.colorId
    );
    return {
      event: 'lab_add_products_added',
      product_style_id: selectedProduct?.id,
      product_style_name: selectedProduct?.name,
      product_color: normalizeTagName(currentColor?.name),
      product_category: selectedProduct?.primary_category_name,
      source: selectedStyle?.styleId
    };
  },
  browseMore: (_, {payload}) => {
    const {source} = payload;
    return {
      event: 'lab_add_products_browse_more',
      source
    };
  }
};

const AddProductsEvents = {
  [AnalyticsTypes.ADD_ITEMS]: AddProducts.start,
  [AnalyticsTypes.ADD_ITEMS_PICK_STYLE]: AddProducts.productSelected,
  [ProductTypes.ADD_PRODUCT]: AddProducts.productAdded,
  [AnalyticsTypes.ADD_ITEMS_BROWSE_MORE]: AddProducts.browseMore
};

export default AddProductsEvents;
